import { ScheduleContribution, Settings, SkipContribution } from "@assets";
import { ActionItem } from "@components/ActionItem";
import { Overlay } from "@components/Overlay";
import { OverlayProps } from "@components/Overlay/types";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Flow, Routes } from "@ctypes";
import { useErrorBanner, useGoalFlow, useGoals, useModal, useNavigateToStep } from "@hooks";
import { i18n, Translations } from "@i18n";
import { PauseContributionModal } from "./PauseContributionModal";
import { SkipContributionModal } from "./SkipContributionModal";
import { EditRecurringContributionModalProps } from "./types";

export const EditRecurringContributionModal = ({ item }: EditRecurringContributionModalProps) => {
  const { show, dismiss } = useModal();
  const { showErrorBanner } = useErrorBanner();

  const navigate = useNavigateToStep();

  const { goals } = useGoals();

  const sipId = goals.find((g) => g.id === item.goalId)?.sips?.[0]?.id;

  const { resetGoalProps } = useGoalFlow();

  const props: OverlayProps = {
    cta: {
      secondary: {
        title: i18n.t(Translations.EditRecurringContributionModalPrimaryCTA),
        onClick: dismiss,
      },
    },
  };

  const { goalId, beneficiaryId, goalName, goalType } = item;

  const handlePause = () => {
    dismiss();
    show(<PauseContributionModal item={item} />);
  };

  const handleSkip = () => {
    dismiss();
    show(<SkipContributionModal item={item} />);
  };

  const handleUpdate = () => {
    if (!goalId || !beneficiaryId) return showErrorBanner();

    dismiss();
    resetGoalProps({
      flow: Flow.EditGoal,
      goalId,
      beneficiaryId,
      ...(goalName && { goalName }),
      ...(goalType && { goalType }),
      ...(sipId && { sipId }),
    });

    navigate(Routes.GoalDeposit);
  };

  return (
    <Overlay {...props}>
      <ActionItem
        leftIcon={<ScheduleContribution size={26} />}
        title={i18n.t(Translations.EditRecurringContributionModalPauseTitle)}
        subtitle={i18n.t(Translations.EditRecurringContributionModalPauseSubtitle)}
        onClick={handlePause}
      />
      <Spacing size={SpacingSizes.M} />

      <ActionItem
        leftIcon={<Settings />}
        title={i18n.t(Translations.EditRecurringContributionModalUpdateTitle)}
        subtitle={i18n.t(Translations.EditRecurringContributionModalUpdateSubtitle)}
        onClick={handleUpdate}
      />
      <Spacing size={SpacingSizes.M} />

      <ActionItem
        leftIcon={<SkipContribution size={28} />}
        title={i18n.t(Translations.EditRecurringContributionModalSkipTitle)}
        subtitle={i18n.t(Translations.EditRecurringContributionModalSkipSubtitle)}
        onClick={handleSkip}
      />
    </Overlay>
  );
};
